import script from "./B2BScheduleAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./B2BScheduleAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./B2BScheduleAdminPage.vue?vue&type=style&index=0&id=b956d074&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b956d074"]])

export default __exports__